<template>
  <Input
    class="user-logged-form__semi-item"
    v-model="email"
    :label="label"
    :error="errorText"
    :disabled="disabled"
    @onBlur="$emit('blur')"
    id="email"
    @onFocus="$emit('onFocus')"
    :placeholder="$t('email_placeholder')"
    :isRequired="isRequired"
  />
</template>

<script>
import Input from './Input'

export default {
  name: 'EmailInput',
  components: { Input },
  props: {
    label: {
      type: String,
      required: false
    },
    emailValue: {
      type: String,
      required: false
    },
    errorText: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      email: '',
      emailError: '',
      emailRegExp: /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
      isValid: true
    }
  },
  methods: {
    emailEmit () {
      this.$emit('getValue', {
        value: this.email,
        isValid: this.isRequired
          ? this.emailRegExp.test(this.email) && !!this.email.length
          : this.emailRegExp.test(this.email)
      })
    }
  },
  watch: {
    email (value) {
      if (value && !this.isRequired) {
        this.email = value.replace(this.emojiRegexp, '')
        this.emailEmit()
      } else if (this.isRequired) {
        this.emailEmit()
      } else {
        this.$emit('getValue', {
          value: '',
          isValid: true
        })
      }
    },
    emailValue (value) {
      this.email = value
    }
  },
  mounted () {
    this.email = this.emailValue
  }
}
</script>

<style scoped lang="sass">
.user-logged-form__item
  width: 100%
</style>
